import apiClient from '@utils/apiClient';
import {
    GrowthDashboardReq,
    GrowthDashboardTopCardInfoRes,
    GrowthDashboardMidCardInfoRes,
    GrowthDashboardLaiCardInfoRes,
    GrowthDashboardTempCardInfoRes,
    GrowthDashboardYieldWeightCardInfoRes,
    GrowingWeightListRes,
    GrowthDashboardDaysReq,
    GrowingSizeListRes,
    CropNitrogenRes,
    GrowthDashboardLightInterceptionCardInfoRes,
    CropPhosphoricAcidRes,
    GrowingRespListRes,
    NutrientFractionationInfoRes,
    SoilLayerMoistureListRes,
    FarmlandWeatherInfoRes,
    SoilTestInfoResData,
    FarmlandRecommendationListRes,
} from '@/api/growth/dashboard/type';

export const api = {
    /**
     * 상단카드정보
     * @param param
     */
    getTopCardInfo: async (
        param: GrowthDashboardReq,
    ): Promise<GrowthDashboardTopCardInfoRes> => {
        const response = await apiClient.post<GrowthDashboardTopCardInfoRes>(
            '/api/v1/growth/dashboard/top/card',
            param,
        );
        return response.data;
    },

    /**
     * 중간카드정보
     * @param param
     */
    getMidCardInfo: async (
        param: GrowthDashboardReq,
    ): Promise<GrowthDashboardMidCardInfoRes> => {
        const response = await apiClient.post<GrowthDashboardMidCardInfoRes>(
            '/api/v1/growth/dashboard/mid/card',
            param,
        );
        return response.data;
    },

    /**
     * 입면적지수정보
     * @param param
     */
    getLaiCardInfo: async (
        param: GrowthDashboardReq,
    ): Promise<GrowthDashboardLaiCardInfoRes> => {
        const response = await apiClient.post<GrowthDashboardLaiCardInfoRes>(
            '/api/v1/growth/dashboard/lai',
            param,
        );
        return response.data;
    },

    /**
     * 일일유효온도정보
     * @param param
     */
    getTempCardInfo: async (
        param: GrowthDashboardReq,
    ): Promise<GrowthDashboardTempCardInfoRes> => {
        const response = await apiClient.post<GrowthDashboardTempCardInfoRes>(
            '/api/v1/growth/dashboard/temp',
            param,
        );
        return response.data;
    },

    /**
     * 예상수확량정보
     * @param param
     */
    getYieldWeightCardInfo: async (
        param: GrowthDashboardReq,
    ): Promise<GrowthDashboardYieldWeightCardInfoRes> => {
        const response =
            await apiClient.post<GrowthDashboardYieldWeightCardInfoRes>(
                '/api/v1/growth/dashboard/yieldweight',
                param,
            );
        return response.data;
    },

    /**
     * 생육무게정보
     * @param param
     */
    getGrowingWeightCardInfo: async (
        param: GrowthDashboardDaysReq,
    ): Promise<GrowingWeightListRes> => {
        const response = await apiClient.post<GrowingWeightListRes>(
            '/api/v1/growth/dashboard/growing/weight',
            param,
        );
        return response.data;
    },

    /**
     * 생육크기정보
     * @param param
     */
    getGrowingSizeCardInfo: async (
        param: GrowthDashboardDaysReq,
    ): Promise<GrowingSizeListRes> => {
        const response = await apiClient.post<GrowingSizeListRes>(
            '/api/v1/growth/dashboard/growing/size',
            param,
        );
        return response.data;
    },

    /**
     * 작물양분-질소
     * @param param
     */
    getCropNitrogenCardInfo: async (
        param: GrowthDashboardDaysReq,
    ): Promise<CropNitrogenRes> => {
        const response = await apiClient.post<CropNitrogenRes>(
            '/api/v1/growth/dashboard/nitrogen',
            param,
        );
        return response.data;
    },

    /**
     * 수광효율정보
     * @param param
     */
    getLightInterceptionCardInfo: async (
        param: GrowthDashboardReq,
    ): Promise<GrowthDashboardLightInterceptionCardInfoRes> => {
        const response =
            await apiClient.post<GrowthDashboardLightInterceptionCardInfoRes>(
                '/api/v1/growth/dashboard/light/interception',
                param,
            );
        return response.data;
    },

    /**
     * 작물양분-인산
     * @param param
     */
    getCropPhosphoricAcidCardInfo: async (
        param: GrowthDashboardDaysReq,
    ): Promise<CropPhosphoricAcidRes> => {
        const response = await apiClient.post<CropPhosphoricAcidRes>(
            '/api/v1/growth/dashboard/phosphoric/acid',
            param,
        );
        return response.data;
    },

    /**
     * 생육호흡정보
     * @param param
     */
    getGrowingRespCardInfo: async (
        param: GrowthDashboardDaysReq,
    ): Promise<GrowingRespListRes> => {
        const response = await apiClient.post<GrowingRespListRes>(
            '/api/v1/growth/dashboard/growing/resp',
            param,
        );
        return response.data;
    },

    /**
     * 토양양분/수분정보
     * @param param
     */
    getGrowingNutrientFractionationCardInfo: async (
        param: GrowthDashboardReq,
    ): Promise<NutrientFractionationInfoRes> => {
        const response = await apiClient.post<NutrientFractionationInfoRes>(
            '/api/v1/growth/dashboard/nutrient/fractionation',
            param,
        );
        return response.data;
    },

    /**
     * 토양층수분정보
     * @param param
     */
    getSoilLayerMoistureCardInfo: async (
        param: GrowthDashboardReq,
    ): Promise<SoilLayerMoistureListRes> => {
        const response = await apiClient.post<SoilLayerMoistureListRes>(
            '/api/v1/growth/dashboard/soilLayer/moisture',
            param,
        );
        return response.data;
    },

    /**
     * 농지주간예보
     * @param param
     */
    getFarmlandWeatherList: async (
        param: GrowthDashboardReq,
    ): Promise<FarmlandWeatherInfoRes> => {
        const response = await apiClient.post<FarmlandWeatherInfoRes>(
            '/api/v1/growth/dashboard/weather/list',
            param,
        );
        return response.data;
    },

    /**
     * 토양정보
     * @param param
     */
    getSoilInfo: async (
        param: GrowthDashboardReq,
    ): Promise<SoilTestInfoResData> => {
        const response = await apiClient.post<SoilTestInfoResData>(
            '/api/v1/growth/dashboard/soil/info',
            param,
        );
        return response.data;
    },

    /**
     * 농작업추천목록
     * @param param
     */
    getFarmingRecomList: async (
        param: GrowthDashboardReq,
    ): Promise<FarmlandRecommendationListRes> => {
        const response = await apiClient.post<FarmlandRecommendationListRes>(
            '/api/v1/growth/dashboard/farming/recom',
            param,
        );
        return response.data;
    },
};
